<template>
  <section class="reviews-page relative">
    <p class="fixed z99 click-disabled"
       ref="details">
      <b>{{ question }}</b>
      <br>
      <span>{{ text }}</span>
    </p>
    <table>
      <thead>
        <tr>
          <th :class="key"
              v-for="(item, key) in tableHead"
              :key="key">
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in reviews"
            :key="index">
          <td>{{ item.name }}</td>
          <td class="questions">
            <div class="flex flex-between">
              <div @mouseenter="handleMouseEnter({question, text})"
                   @mouseleave="handleMouseLeave()"
                   class="flex align-center"
                   v-for="({ question, rating, text }, index) in item.questions"
                   :key="index">
                <div v-show="index < 4">
                  <BaseRating :question="question"
                              :text="text"
                              :rating="+rating" />
                </div>
                <i v-show="index === 4">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1ZM11.5 6C11.2348 6 10.9804 6.10536 10.7929 6.29289C10.6054 6.48043 10.5 6.73478 10.5 7C10.5 7.26522 10.6054 7.51957 10.7929 7.70711C10.9804 7.89464 11.2348 8 11.5 8H12C12.2652 8 12.5196 7.89464 12.7071 7.70711C12.8946 7.51957 13 7.26522 13 7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6H11.5ZM10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11C9 11.2652 9.10536 11.5196 9.29289 11.7071C9.48043 11.8946 9.73478 12 10 12H11V15H10C9.73478 15 9.48043 15.1054 9.29289 15.2929C9.10536 15.4804 9 15.7348 9 16C9 16.2652 9.10536 16.5196 9.29289 16.7071C9.48043 16.8946 9.73478 17 10 17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5196 15.1054 14.2652 15 14 15H13V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10H10Z" fill="#F5AA16"/>
                  </svg>
                </i>
                <i v-show="index === 5"
                   class="block mleft10px">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1ZM11.5 6C11.2348 6 10.9804 6.10536 10.7929 6.29289C10.6054 6.48043 10.5 6.73478 10.5 7C10.5 7.26522 10.6054 7.51957 10.7929 7.70711C10.9804 7.89464 11.2348 8 11.5 8H12C12.2652 8 12.5196 7.89464 12.7071 7.70711C12.8946 7.51957 13 7.26522 13 7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6H11.5ZM10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11C9 11.2652 9.10536 11.5196 9.29289 11.7071C9.48043 11.8946 9.73478 12 10 12H11V15H10C9.73478 15 9.48043 15.1054 9.29289 15.2929C9.10536 15.4804 9 15.7348 9 16C9 16.2652 9.10536 16.5196 9.29289 16.7071C9.48043 16.8946 9.73478 17 10 17H14C14.2652 17 14.5196 16.8946 14.7071 16.7071C14.8946 16.5196 15 16.2652 15 16C15 15.7348 14.8946 15.4804 14.7071 15.2929C14.5196 15.1054 14.2652 15 14 15H13V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10H10Z" fill="#39BB9D"/>
                  </svg>
                </i>
              </div>
            </div>
          </td>
          <td>{{ moment(item.created_at).format('DD MMM YYYY') }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import {mapState} from "vuex";
import moment from 'moment';
import BaseRating from "@/components/BaseRating";

export default {
  name: 'Reviews',
  components: {
    BaseRating
  },
  data () {
    return {
      tableHead: {
        name: 'nume',
        questions: 'calificative',
        created_at: 'data'
      },
      question: undefined,
      text: undefined,
      moment
    }
  },
  created () {
    this.$store.dispatch('get_reviews');
  },
  mounted () {
    document.addEventListener('mousemove', this.mouseMove, {passive: true})
  },
  computed: {
    ...mapState({
      reviews: state => state.reviews.data
    })
  },
  methods: {
    mouseMove (ev) {
      this.$refs.details.style.left = `${ev.pageX + 8}px`
      this.$refs.details.style.top = `${ev.pageY + 8}px`
    },
    handleMouseEnter (item) {
      document.addEventListener('mousemove', this.mouseMove, {passive: true})
      this.$refs.details.style.display = 'block'
      this.question = item.question
      this.text = item.text
    },
    handleMouseLeave () {
      document.removeEventListener('mousemove', this.mouseMove)
      this.$refs.details.style.display = 'none'
    }
  },
  destroyed () {
    document.removeEventListener('mousemove', this.mouseMove)
  }
}
</script>

<style lang="less">
  .reviews-page {
    width: 100%;
    padding-top: 100px;
    p.fixed {
      display: none;
      font-size: 1.5rem;
      width: 260px;
      background-color: white;
      border-radius: 2px;
      border: 1px solid lightgray;
      padding: 8px;
    }
    table {
      width: 100%;
      max-width: 940px;
      text-align: left;
      thead {
        font-size: 1.6rem;
        color: #686868;
        th {
          border-bottom: 1px solid lightgray;
          padding-bottom: 6px;
        }
      }
      tbody {
        td {
          text-transform: capitalize;
          padding: 12px 0 0;
          font-size: 1.6rem;
          color: #2f2f2f;
        }
        i {
          display: inline-block;
          transform: translateY(1px);
        }
      }
      .name {
        width: 240px;
      }
      .questions {
        width: 480px;
        padding-right: 20px;
      }
    }
  }
  .reviews-page + .tab-bar {
    display: none;
  }
</style>
